import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ExportPdfRequest {
  includeHelpTexts: boolean;
}

export interface ExportComparisonPdfRequest {
  calculationIds: number[];
  includeHelpTexts: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CalculationPdfExportService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/calculations`;

  exportCalculationPdf(calculationId: number, includeHelpTexts: boolean): Observable<Blob> {
    const request: ExportPdfRequest = { includeHelpTexts };
    
    return this.http.post(
      `${this.baseUrl}/${calculationId}/export-pdf`,
      request,
      { responseType: 'blob' }
    );
  }

  exportComparisonPdf(calculationIds: number[], includeHelpTexts: boolean): Observable<Blob> {
    const request: ExportComparisonPdfRequest = { calculationIds, includeHelpTexts };
    
    return this.http.post(
      `${this.baseUrl}/export-comparison-pdf`,
      request,
      { responseType: 'blob' }
    );
  }

  downloadFile(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(url);
  }
}
